export default {
  // Generic
  'generic.add': 'Añadir',
  'generic.cancel': 'Cancelar',

  // BlockType
  'components.controls.blocktype.h1': 'H1',
  'components.controls.blocktype.h2': 'H2',
  'components.controls.blocktype.h3': 'H3',
  'components.controls.blocktype.h4': 'H4',
  'components.controls.blocktype.h5': 'H5',
  'components.controls.blocktype.h6': 'H6',
  'components.controls.blocktype.blockquote': 'Blockquote',
  'components.controls.blocktype.code': 'Código',
  'components.controls.blocktype.blocktype': 'Tipo de bloque',
  'components.controls.blocktype.normal': 'Normal',

  // Color Picker
  'components.controls.colorpicker.colorpicker': 'Seleccionar color',
  'components.controls.colorpicker.text': 'Texto',
  'components.controls.colorpicker.background': 'Subrayado',

  // Embedded
  'components.controls.embedded.embedded': 'Adjuntar',
  'components.controls.embedded.embeddedlink': 'Adjuntar Link',
  'components.controls.embedded.enterlink': 'Introducir link',

  // Emoji
  'components.controls.emoji.emoji': 'Emoji',

  // FontFamily
  'components.controls.fontfamily.fontfamily': 'Fuente',

  // FontSize
  'components.controls.fontsize.fontsize': 'Tamaño de fuente',

  // History
  'components.controls.history.history': 'Histórico',
  'components.controls.history.undo': 'Deshacer',
  'components.controls.history.redo': 'Rehacer',

  // Image
  'components.controls.image.image': 'Imagen',
  'components.controls.image.fileUpload': 'Subir archivo',
  'components.controls.image.byURL': 'URL',
  'components.controls.image.dropFileText':
    'Arrastra el archivo o haz click para subirlo',

  // Inline
  'components.controls.inline.bold': 'Negrita',
  'components.controls.inline.italic': 'Cursiva',
  'components.controls.inline.underline': 'Subrayado',
  'components.controls.inline.strikethrough': 'Tachado',
  'components.controls.inline.monospace': 'Monospace',
  'components.controls.inline.superscript': 'Sobreíndice',
  'components.controls.inline.subscript': 'Subíndice',

  // Link
  'components.controls.link.linkTitle': 'Título del enlace',
  'components.controls.link.linkTarget': 'Objetivo del enlace',
  'components.controls.link.linkTargetOption': 'Abrir en nueva ventana',
  'components.controls.link.link': 'Enlazar',
  'components.controls.link.unlink': 'Desenlazar',

  // List
  'components.controls.list.list': 'Lista',
  'components.controls.list.unordered': 'Desordenada',
  'components.controls.list.ordered': 'Ordenada',
  'components.controls.list.indent': 'Indentada',
  'components.controls.list.outdent': 'Dentada',

  // Remove
  'components.controls.remove.remove': 'Eliminar',

  // TextAlign
  'components.controls.textalign.textalign': 'Alineación del texto',
  'components.controls.textalign.left': 'Izquierda',
  'components.controls.textalign.center': 'Centrado',
  'components.controls.textalign.right': 'Derecha',
  'components.controls.textalign.justify': 'Justificado',

  // New Examod localizations
  'components.controls.image.modal.title': 'Image Uploader',
  'components.controls.image.modal.description':
    'Browse or drag the image you want to upload',
  'components.controls.image.modal.content.image.or': 'or',
  'components.controls.image.modal.content.image.btn': 'Browse Files',
  'components.controls.image.modal.content.image.attachment':
    'Attachments should not exceed 2 mb',
  'components.controls.image.modal.content.image.supported':
    'Supported file types: JPEG, JPG, PNG',
  'components.controls.image.modal.content.input.alt.label': 'Alt Text',
  'components.controls.image.modal.content.input.alt.placeholder':
    'Image alt text',
  'components.controls.image.modal.content.input.scale.label': 'Scale (%)',
  'components.controls.image.modal.contnet.url.address.label': '*URL (Adress)',
  'components.controls.image.modal.link.title': 'URL',
  'components.controls.image.modal.link.description': 'Add image from address',

  // New Highlight Colors 'Clear Highlight'
  'components.controls.color.picker.highlight.clear': 'Clear Highlight',
  'components.controls.color.picker.highlight.black': 'Black Highlight',
  'components.controls.color.picker.highlight.grey': 'Grey Highlight',
  'components.controls.color.picker.highlight.red': 'Red Highlight',
  'components.controls.color.picker.highlight.green': 'Green Highlight',
  'components.controls.color.picker.highlight.blue': 'Blue Highlight',
  'components.controls.color.picker.highlight.yellow': 'Yellow Highlight',
  'components.controls.color.picker.highlight.examod': 'Examod Highlight',
  'components.controls.color.picker.highlight.purple': 'Purple Highlight',
  'components.controls.color.picker.highlight.pink': 'Pink Highlight',
};
